import { SIMPLE_VALUES } from "../actions/types";

const initState = {
  simplething: false
};

const simpleReducer = (state = initState, action) => {
  switch (action.type) {
    case SIMPLE_VALUES:
      return {
        ...state,
        type: SIMPLE_VALUES,
        simplething: action.simple_action
      };

    default:
      return state;
  }
};

export default simpleReducer;
